export enum SuchenPlusLevel {
  Light = 'LIGHT',
  Standard = 'STANDARD',
  Pro = 'PRO',
  Unlimited = 'UNLIMITED',
  Legacy = 'LEGACY',
}

export type SuchenPlusStatus = {
  mieter: {
    functionalities: string[];
    level: SuchenPlusLevel | null;
  };
};
